import { EmptyCard } from '@pms-digital/design-system';

export interface NewMatrixCardProps {
  disabled: boolean;
  onClick: () => void;
}

/**
 * "+ Nouvelle matrice" card. Unlike `NewCompanyCard`, this isn't a plain
 * `Link` — clicking it does `POST /matrices` then navigates (see decision 8),
 * so it's a button the parent wires up. Disabled when the company's
 * singularity setup is incomplete, never a silent no-op link.
 *
 * Decision 8 originally put the *reason* for being disabled in a `Banner`
 * inside this card. That reason now lives in a single page-level banner under
 * the tab bar (`CompanySpacePage`), so it renders once, in one place, on both
 * tabs, instead of being duplicated between here and the settings panel. This
 * card therefore no longer explains itself — the explanation is above it.
 *
 * The place is held by the package's `EmptyCard` (dashed outline), clickable
 * as a whole like the original card.
 */
export function NewMatrixCard({ disabled, onClick }: NewMatrixCardProps) {
  return (
    <EmptyCard
      tone="accent"
      icon="add"
      message="Nouvelle matrice"
      disabled={disabled}
      onClick={onClick}
    />
  );
}
